import moment from 'moment'
import numeral from 'numeral'

const limitHour = moment({ hour: 16, minute: 5 })
const minDate = moment() < limitHour ? moment({ hour: 0 }) : moment({ hour: 0 }).add(1, 'day')

export const generalData = {
  estatusOrden: {
    value: '',
    name: 'estatusOrden',
    label: 'Estatus Orden',
    valueProperty: 'id',
    valueLabel: 'estatus',
    disabled: true,
  },
  fechaProgramacionEmisionFactura: {
    name: 'fechaProgramacionEmisionFactura',
    value: minDate.toDate(),
    minDate: minDate.toDate(),
    label: 'Fecha de programación del depósito',
    validation: 'required',
    dataMarshaller: (value) => moment(value).format('YYYY-MM-DD')
  },
  tipoDePersona: {
    value: '',
    trigger: 'onChangeTipoPersona',
    transform: 'stringToNumber',
    name: 'tipoPersona',
    label: 'Tipo de persona',
    disabled: true,
  },
  rfc: {
    value: '',
    name: 'rfc',
    label: 'RFC',
    disabled: true,
  },
  correoElectronico: {
    value: '',
    name: 'correoElectronico',
    label: 'Correo Electrónico',
    disabled: true,
  },
  nombreORazonSocial: {
    value: '',
    name: 'nombreRazonSocial',
    label: 'Nombre o Razón Social',
    disabled: true,
  },
  numRegIdTrib: {
    value: '',
    name: 'numRegIdTrib',
    label: 'Tax Id Number (Sólo para extranjeros)',
    disabled: true,
  },
  cuentaCobranza: {
    value: '',
    name: 'cuentaCobranza',
    label: 'Cuenta para Cobranza',
    validation: 'required',
    options: [
      {
        label: 'MXN',
        value: 'MXN'
      },
      {
        label: 'USD',
        value: 'USD'
      }
    ]
  },
  netoDepositar:{
    value: '',
    pattern: 'number',
    label: 'Neto a depositar',
    name: 'netoDepositar',
    validation: 'required',
  }


}
export const depositsList =
  [
    {
      title: 'ID',
      datakey: 'id',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Estatus Orden',
      datakey: 'estatusTexto',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Nombre o Razón Social',
      datakey: 'nombreORazonSocial',
      sortable: true,
      width: '40%',
    },
    {
      title: 'Total',
      datakey: 'Total',
      format: '$ 0,0.00',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '10%',
    },
  ]

export const addressData = {
  direccion: {
    value: '',
    transform: 'stringToBool',
    trigger: 'onChangeDireccion',
    name: 'direccion',
    label: 'Dirección',
    disabled: true,
  },
  pais: {
    name: 'pais',
    value: '',
    validation: 'requiredIf:direccion',
    label: 'País',
    disabled: true
  },
  codigoPostal: {
    value: '',
    trigger: 'onChangeCp',
    pattern: 'number',
    name: 'codigoPostal',
    label: 'Código postal',
    disabled: true,
  },
  entidadFederativa: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'entidadFederativa',
    label: 'Entidad Federativa/Estado/Provincia',
    disabled: true,
  },
  municipio: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'municipio',
    label: 'Municipio',
    disabled: true,
  },
  colonia: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'colonia',
    label: 'Colonia',
    disabled: true,
  },
  calle: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'calle',
    label: 'Calle',
    disabled: true,
  },
  exterior: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'exterior',
    label: 'Exterior',
    disabled: true,
  },
  interior: {
    value: '',
    name: 'interior',
    label: 'Interior',
    disabled: true,
  },
}
export const conceptData = {
  concepto: {
    name: 'concepto',
    label: 'Concepto',
    value: '',
    validation: 'required',
  },
  unidad: {
    name: 'unidad',
    label: 'Unidad',
    value: '',
    validation: 'required',
    placeholder: 'Buscar unidad...',
  },
  unitario: {
    name: 'unitario',
    label: 'Unitario',
    value: '',
    validation: 'required',
    pattern: 'number',
    trigger: 'updateCalculations',
  },
  total: {
    name: 'total',
    label: 'Total',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  iva: {
    name: 'iva',
    label: 'IVA',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ieps: {
    name: 'ieps',
    label: 'IEPS',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  cantidad: {
    name: 'cantidad',
    label: 'Cantidad',
    pattern: 'number',
    value: '',
    validation: 'required',
    trigger: 'updateCalculations',
  },
  tasaIeps: {
    name: 'tasaIeps',
    label: 'Tasa IEPS',
    value: '',
    // validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
    trigger: 'updateCalculations',
  },
  tasaIva: {
    name: 'tasaIva',
    label: 'Tasa IVA',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
    trigger: 'updateCalculations',
  },
  tipoCalculo: {
    name: 'tipoCalculo',
    label: 'Tipo de Cálculo',
    value: 1,
    validation: 'required',
    transform: 'stringToNumber',
    trigger: 'updateCalculations',
    options: [
      {
        value: 1,
        label: 'El IVA Grava sobre Subtotal'
      },
      {
        value: 2,
        label: 'El IVA Grava sobre Subtotal + IEPS'
      },
    ],
  },
  claveProductoServicioSAT: {
    name: 'claveProductoServicioSAT',
    label: 'Clave Producto Servicio',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
  },
  identificador: {
    name: 'identificador',
    label: 'Identificador',
    maxLength: 11,
    value: '',
  },
  tasaIVA: {
    same: 'tasaIva',
  },
  tasaIEPS: {
    same: 'tasaIeps',
  },
  query: {
    name: 'query',
    label: 'Buscar producto o servicio por concepto o identificador',
    value: '',
  },
}
export const conceptsCol = [
  {
    title: 'Concepto',
    datakey: 'concepto',
  },
  {
    title: 'Subtotal',
    datakey: 'subtotal',
    format: '$ 0,0.00',
  },
  {
    title: 'IVA',
    datakey: 'iva',
    format: '$ 0,0.00',
  },
  {
    title: 'Total',
    datakey: 'total',
    format: '$ 0,0.00',
  },
  {
    title: 'Acciones',
    custom: 'acciones',
  }
]
export const paymentCol = [
  {
    title: 'Id',
    datakey: 'id',
  },
  {
    title: 'Fecha de transacción',
    datakey: 'fechaTransaccion',
    format: (value) => moment(value).format('DD/MM/YYYY')
  },
  {
    title: 'Estatus',
    datakey: 'estatusTexto',
  },
  {
    title: 'Abono',
    datakey: 'abonos',
    format: '$ 0,0.00',
  },
  {
    title: 'Moneda',
    datakey: 'monedaDivisa',
  },
  {
    title: 'Referencia del banco',
    datakey: 'referenciaBanco',
  },
]
export const complementaryPaymentCol = [
  {
    title: 'Fecha Uiid',
    datakey: 'FechaUUID',
    format: (value) => moment(value).format('DD/MM/YYYY'),
  },
  {
    title: 'Uuid',
    datakey: 'uuid',
  },
  {
    title: 'Serie & Folio',
    datakey: 'serieFolio',
  },
  {
    title: 'Importe Pagado',
    datakey: 'impPagado',
    format: '$ 0,0.00',
  },
  {
    title: 'Forma de Pago',
    datakey: 'formaDePagoTxt',
  },
]

export const totals = {
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  iva: {
    name: 'iva',
    label: 'IVA',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ieps: {
    name: 'ieps',
    label: 'IEPS',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoCobrado: {
    name: 'montoCobrado',
    label: 'Monto Cobrado',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoPorCobrar: {
    name: 'montoPorCobrar',
    label: 'Monto Por Cobrar',
    value: 0,
    format: (value) => numeral(Math.round(+value * 100)/100).format('$ 0,0.00'),
    align: 'right',
  },
  numeroFactura: {
    name: 'numeroFactura',
    label: 'Numero de factura',
  },
  uuid: {
    name: 'uuid',
    label: 'UUID',
    disabled: true,
  },
  total: {
    name: 'total',
    label: 'Total',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
}